module.exports = __webpack_public_path__ + "static/media/letter_6@3x.0431db47.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_6@3x.png
// module id = 594
// module chunks = 0